module.exports = __webpack_public_path__ + "img/petstairs40.5f574b3c.jpg";